"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonRegistry = void 0;
const sol_did_client_1 = require("@identity.com/sol-did-client");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("./constants");
const util_1 = require("./util");
/**
 * A common base class for all registries (key and controller)
 */
class CommonRegistry {
    constructor(address, seedPrefix, cluster) {
        this.address = address;
        this.seedPrefix = seedPrefix;
        this.cluster = cluster;
        [this.registryAddress, this.registryBump] =
            this.getRegistryAddressAndBump();
    }
    confirm(txSig) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, util_1.confirm)(this.program.provider.connection, txSig);
        });
    }
    didToAccount(did) {
        const didSolIdentifier = sol_did_client_1.DidSolIdentifier.parse(did);
        const [didAccount, didBump] = didSolIdentifier.dataAccount();
        return {
            authority: didSolIdentifier.authority,
            account: didAccount,
            bump: didBump,
        };
    }
    getRegistryAddressAndBump() {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from(this.seedPrefix), this.address], constants_1.DID_REGISTRY_PROGRAM_ID);
    }
}
exports.CommonRegistry = CommonRegistry;
//# sourceMappingURL=CommonRegistry.js.map